import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router";
import ErrorFallback from "@/shared/components/ErrorFallback";
import { OldBrowserAlert } from "@/shared/components/OldBrowserAlert";
import AppProvider from "@/shared/contexts/AppProvider";
import { ThemeProvider } from "@/shared/contexts/ThemeProvider";
import { useVersionCheck } from "@/shared/hooks/useVersionCheck";
import { queryClient } from "@/shared/lib/queryClient";
import { Sentry } from "@/shared/services/sentry.service";
import { Toaster } from "@/shared/ui/Sonner";
import AppRouter from "./AppRouter";
import BridgeTransferListener from "./BridgeTransferListener";
import UsageTrackingProvider from "./usage-tracking/UsageTrackingProvider";

const VersionChecker = () => {
  useVersionCheck();
  return null;
};

/**
 * Main application component with all providers
 * Separates provider setup from DOM rendering (main.tsx)
 */
export const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AppProvider>
              <OldBrowserAlert />
              <VersionChecker />
              <BridgeTransferListener />
              <UsageTrackingProvider>
                <AppRouter />
              </UsageTrackingProvider>
              <Toaster richColors />
            </AppProvider>
          </BrowserRouter>
          {import.meta.env.DEV && import.meta.env.VITE_RQ_DEVTOOLS !== "false" && (
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
          )}
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
